import { ReactNode } from 'react';

import { useAuthorisedAction } from 'approot/shared/hooks/authorised-action.hooks';
import { ContentCardLink } from 'approot/shared/content-card/content-card-parts';
import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import { WorksheetCard } from '../worksheet-card/worksheet-card.style';
import * as Styled from './simple-card.style';

export const SimpleCard = ({
  title,
  ariaTitle,
  link,
  imageRatio,
  bodyText,
  actionItems,
  openInNewTab,
  onClick,
}: {
  title?: ReactNode;
  link?: string;
  ariaTitle: string;
  imageRatio?: number;
  bodyText?: ReactNode;
  actionItems?: ReactNode;
  openInNewTab?: boolean;
  onClick?: () => void;
}) => {
  const { unauthorisedAccessHref } = useAuthorisedAction();

  const href = unauthorisedAccessHref();

  return (
    <Styled.SimpleCardWrapper>
      <Styled.SimpleCardBox data-selector="content-card-box">
        {link && (
          <ContentCardLink
            href={href ? href : link}
            openInTab={openInNewTab}
            screenReaderText={ariaTitle}
            onClick={() => onClick?.()}
          />
        )}

        <WorksheetCard $ratio={imageRatio}>
          <Styled.SimpleCardInner>
            {bodyText && bodyText}
          </Styled.SimpleCardInner>
        </WorksheetCard>
        {title && (
          <Styled.SimpleCardTitle aria-hidden data-selector="card-title">
            {title}
          </Styled.SimpleCardTitle>
        )}

        {actionItems && (
          <Styled.SimpleCardActions>{actionItems}</Styled.SimpleCardActions>
        )}
      </Styled.SimpleCardBox>
    </Styled.SimpleCardWrapper>
  );
};

export const SimpleCardButton = ({
  title,
  ariaTitle,
  imageRatio,
  bodyText,
  actionItems,
  isSelected,
  onClick,
  ...rest
}: {
  title?: ReactNode;
  ariaTitle: string;
  imageRatio?: number;
  bodyText?: ReactNode;
  actionItems?: ReactNode;
  isSelected?: boolean;
  onClick: () => void;
  ['data-testid']?: string;
}) => {
  return (
    <Styled.SimpleCardWrapper>
      <Styled.SimpleCardBox>
        <Styled.SimpleCardButton
          type="button"
          data-testid={rest['data-testid']}
          onClick={onClick}
        >
          <ScreenReaderOnly>{ariaTitle}</ScreenReaderOnly>
        </Styled.SimpleCardButton>
        <WorksheetCard $ratio={imageRatio} $isSelected={isSelected}>
          {bodyText && bodyText}
        </WorksheetCard>
        {title && (
          <Styled.SimpleCardTitle aria-hidden data-selector="card-title">
            {title}
          </Styled.SimpleCardTitle>
        )}
        {actionItems && (
          <Styled.SimpleCardActions>{actionItems}</Styled.SimpleCardActions>
        )}
      </Styled.SimpleCardBox>
    </Styled.SimpleCardWrapper>
  );
};
